import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { Tooltip, useMediaQuery } from '@mui/material'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { find } from 'lodash'
import { FC, MouseEventHandler } from 'react'
import { LLMModelDTO } from '../../../../api/gen/base'
import { OnboardingTooltip } from '../../../../components/Wrapper/NavigationSidebar/components/OnboardingTooltip'
import { useWrapperStore } from '../../../../store/storeWrapper'
import { theme } from '../../../../theme'
import { ModelIcon } from './ModelIcon'

type Props = {
    modelList: LLMModelDTO[]
    handleClick: MouseEventHandler<HTMLButtonElement>
    isRequestsSetting?: boolean
    isDisabled?: boolean
    isAssistantActive?: boolean
}

export const AgentOrAssistantButton: FC<Props> = ({
    handleClick,
    modelList,
    isRequestsSetting,
    isDisabled,
    isAssistantActive,
}) => {
    const { currentAgentNameInDialog, currentAssistantDataInDialog, stepOnboarding, dialogsOpen } =
        useWrapperStore((state) => state)
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))

    return (
        <>
            {!isMobile && stepOnboarding === 1 ? (
                <OnboardingTooltip
                    placement="bottom-start"
                    open={stepOnboarding === 1}
                    title="Автопилот"
                    decription="Сам выбирает подходящую модель под ваш запрос. Не нужно разбираться — всё делается автоматически, но можно выбрать любую модель или ассистента">
                    {' '}
                    <Button
                        disabled={isDisabled || stepOnboarding === 1}
                        fullWidth={isRequestsSetting}
                        sx={{
                            padding: '8px 16px',
                            whiteSpace: 'nowrap',
                            backgroundColor:
                                !isMobile && stepOnboarding === 1 ? '#EBF5FD !important' : '#fff',
                            zIndex: !isMobile && stepOnboarding === 1 ? 1304 : 0,
                            border: '1px solid #E5E5E7',
                            '&:hover': {
                                background: '#F6F6F6',
                                border: '1px solid #E5E5E7',
                            },
                        }}
                        onClick={handleClick}
                        endIcon={<KeyboardArrowDownIcon />}
                        variant={isRequestsSetting ? 'outlined' : 'contained'}
                        color={isRequestsSetting ? 'primary' : 'secondary'}>
                        {!isAssistantActive ? (
                            <>
                                <ModelIcon agentKey={currentAgentNameInDialog} />
                                <Typography
                                    sx={{
                                        maxWidth: '128px',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        fontSize: '12px',
                                    }}
                                    variant="h6">
                                    {find(modelList, { slug: currentAgentNameInDialog })?.title}
                                </Typography>
                            </>
                        ) : (
                            <Typography
                                sx={{
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    fontSize: '12px',
                                }}
                                variant="h6">
                                {currentAssistantDataInDialog?.name}
                            </Typography>
                        )}
                    </Button>
                </OnboardingTooltip>
            ) : (
                <Tooltip title="Выбор модели или ассистента">
                    <Button
                        disabled={isDisabled || stepOnboarding === 1}
                        fullWidth={isRequestsSetting}
                        sx={{
                            padding: '8px 16px',
                            whiteSpace: 'nowrap',
                            backgroundColor:
                                !isMobile && stepOnboarding === 1 ? '#EBF5FD !important' : '#fff',
                            zIndex: !isMobile && stepOnboarding === 1 ? 1304 : 0,
                            border: '1px solid #E5E5E7',
                            '&:hover': {
                                background: '#F6F6F6',
                                border: '1px solid #E5E5E7',
                            },
                        }}
                        onClick={handleClick}
                        endIcon={<KeyboardArrowDownIcon />}
                        variant={isRequestsSetting ? 'outlined' : 'contained'}
                        color={isRequestsSetting ? 'primary' : 'secondary'}>
                        {!isAssistantActive ? (
                            <>
                                <ModelIcon agentKey={currentAgentNameInDialog} />
                                <Typography
                                    sx={{
                                        maxWidth: '128px',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        fontSize: '12px',
                                    }}
                                    variant="h6">
                                    {find(modelList, { slug: currentAgentNameInDialog })?.title}
                                </Typography>
                            </>
                        ) : (
                            <Typography
                                sx={{
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    fontSize: '12px',
                                }}
                                variant="h6">
                                {currentAssistantDataInDialog?.name}
                            </Typography>
                        )}
                    </Button>
                </Tooltip>
            )}
        </>
    )
}
